export function getLayerTreeExpandedKeysSessionKey(projectId: string) {
  return `project-expanded-tree-keys::${projectId}`;
}
